export default {
  title: 'Verificación de datos biométricos',
  titleDescription: 'Es necesario verificar la identidad del beneficiario para continuar',
  allowCamera: 'Permita el acceso a la cámara en su navegador',
  tabs: {
    facial: 'Reconocimiento facial',
    finger: 'Huella dactilar'
  },
  buttons: {
    capture: 'Capturar',
    retry: 'Volver a intentar',
    confirm: 'Confirmar'
  },
  biometricValidation: {
    success: 'Verificación exitosa',
    fail: 'Error en la verificación'
  },
  instructions: {
    title: 'Datos biométricos del beneficiario',
    subtitle: 'Es necesario capturar el rostro de la persona para verificar su identidad',
    buttonLabel: 'Comenzar',
    steps: {
      step1: {
        title: 'Paso 1',
        description: 'Coloque la cámara a la altura del rostro del asegurado'
      },
      step2: {
        title: 'Paso 2',
        description: 'Asegúrese de que haya luz suficiente'
      },
      step3: {
        title: 'Paso 3',
        description: 'Enmarque el rostro dentro de los límites mostrados'
      }
    }
  },
  captureFinger: 'Inicie la captura de la huella dactilar',
  fingerprint: {
    title: 'Datos biométricos del beneficiario',
    subtitle: 'Es necesario capturar la huella dactilar para verificar su identidad',
    buttonLabel: 'Comenzar',
    steps: {
      step1: {
        title: 'Paso 1',
        description:
          'Posicione el dedo del asegurado firmemente sobre el lector de huellas dactilares'
      },
      step2: {
        title: 'Paso 2',
        description: 'Asegúrese de que el dedo esté limpio y seco para una captura precisa'
      },
      step3: {
        title: 'Paso 3',
        description: 'Confirme que el dedo esté completamente cubierto por el lector'
      }
    },
    errors: {
      initializedFingerprintDevice:
        'El dispositivo no está inicializado o conectado. Por favor, verifique la conexión e intente nuevamente.',
      timeOutFingerprintDevice: 'La captura de huella ha caducado. Por favor, intente nuevamente.',
      agentNotConfigured:
        'El servicio de huellas digitales no está instalado o no responde. Por favor, verifique la configuración e intente nuevamente.',
      captureAlreadyStarted:
        'La captura ya ha comenzado. Por favor, detenga la captura actual antes de iniciar una nueva.',
      captureStop: 'La captura se ha detenido. Por favor, intente nuevamente.',
      defaultError:
        'Algo salió mal con la captura de la huella digital. Por favor, vuelva a intentarlo.'
    }
  }
}
